import {
  FETCH_INVENTORY_REPORT,
  FETCH_INVENTORY_REPORT_SUCCESS,
  FETCH_INVENTORY_REPORT_FAIL,
} from './actionTypes';

export const fetchInventoryReport = (params = {}) => ({
  type: FETCH_INVENTORY_REPORT,
  payload: params,
});

export const fetchInventoryReportSuccess = (data) => ({
  type: FETCH_INVENTORY_REPORT_SUCCESS,
  payload: data,
});

export const fetchInventoryReportFail = (error) => ({
  type: FETCH_INVENTORY_REPORT_FAIL,
  payload: error,
});
